import { render, staticRenderFns } from "./zh.vue?vue&type=template&id=397b39d3&scoped=true"
import script from "./zh.vue?vue&type=script&lang=js"
export * from "./zh.vue?vue&type=script&lang=js"
import style0 from "./zh.vue?vue&type=style&index=0&id=397b39d3&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "397b39d3",
  null
  
)

export default component.exports